import React, { PropsWithChildren } from 'react'
import { Box, Icon, IconName, Box as List, Box as ListItem, Text } from '@node-space/ui-components'

export interface IconListItem {
  iconName: IconName
  text: string
}

export interface IconListItemProps extends PropsWithChildren {
  items: IconListItem[]
  className?: string
}

export const IconList = ({ items, className }: IconListItemProps) => {
  return (
    <List flexCol paddingT={24} gap={12} {...(className && { className })}>
      {items?.map(({ iconName, text }) => (
        <ListItem key={iconName} flex gap={8} align="center">
          <Box
            flex
            centerChildren
            size={32}
            background="standard"
            borderRadius="full"
            className="text-status-accent-info"
            flexSize="keep"
          >
            <Icon name={iconName} />
          </Box>
          <Text tag="h4" variant="heading-4" color="subdued">
            {text}
          </Text>
        </ListItem>
      ))}
    </List>
  )
}
